import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Toast from "../../utils/toast";
import Loader from "../Loader";
import createInstance from "../../api/axiosinstance";
import "../commonLogin.css";
import { Button, Link } from "@mui/material";
import { loginSuccess, checkUserType } from "../../Redux/slices/authSlice";

const OtpAuth = () => {
  const dispatch = useDispatch();
  const [otp, setOTP] = useState(["", "", "", "", "", ""]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const aiDishaApi = createInstance("DISHA");
  const location = useLocation();
  const { email, source } = location.state || { email: "", source: "" };

  // Get role from Redux store
  const role = useSelector(
    (state) => state.auth.user?.role || state.auth.userType
  );

  // Fetch role if not available
  useEffect(() => {
    if (!role && email && source) {
      dispatch(checkUserType(email));
    }
  }, [dispatch, email, role, source]);

  const handleChange = (index, e) => {
    const value = e.target.value;
    if (!isNaN(value) && value.length <= 1) {
      const newOTP = [...otp];
      newOTP[index] = value;
      setOTP(newOTP);
      if (index < 5 && value !== "") {
        e.target.nextElementSibling && e.target.nextElementSibling.focus();
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const enteredOTP = otp.join("");
    if (enteredOTP.length === 6) {
      let endpoint;
      console.log("selecting end point : ", source);
      console.log("role:", role);
      if (source === "candidateLogin") {
        endpoint = "/Verify-OTP/";
      } else if (source === "register") {
        if (role === "Admin") {
          endpoint = "/admin-user-Register-Verify-OTP/";
        } else if (
          role === "Interviewer" ||
          role === "OrgAdmin" ||
          role === "HR"
        ) {
          endpoint = "/org-user-Register-Verify-OTP/";
        }
      } else if (source === "forget-password") {
        if (role === "Admin") {
          endpoint = "/admin-user-Forget-Password/Verify-OTP/";
        } else if (
          role === "Interviewer" ||
          role === "OrgAdmin" ||
          role === "HR"
        ) {
          endpoint = "/org-user-Forget-Password/Verify-OTP/";
        } else if (role === "TP-Interviewer") {
          endpoint = "/interviewer_Verify_OTP/";
        }
      } else if (source === "interviewerRegister") {
        endpoint = "/interviewer_Verify_OTP/";
      } else {
        setError("Invalid source provided.");
        setLoading(false);
        return;
      }

      if (!endpoint) {
        setError("Unable to determine endpoint. Please try again.");
        setLoading(false);
        return;
      }

      try {
        const response = await aiDishaApi.post(endpoint, {
          email: email,
          otp: parseInt(enteredOTP, 10),
        });
        if (response.status === 200) {
          console.log("after otp v canidatelogin", response);
          const data = response.data;
          dispatch(
            loginSuccess({
              name: null,
              role: "Candidate",
              organizationId: data.organization_id,
              candidateId: data.candidate_id,
              accessToken: data.access_token || "token",
            })
          );
          Toast.success(response.data.message);
          if (source === "candidateLogin") {
            window.sessionStorage.setItem("candEmail", email);
            navigate("/candidateLanding");
          } else if (source === "register") {
            navigate("/success", { state: { source: "register" } });
          } else if (source === "forget-password") {
            navigate("/updatePassword", {
              state: { email: email, otp: enteredOTP, role: role },
            });
          } else if (source === "interviewerRegister") {
            navigate("/success", { state: { source: "register" } });
          }
        } else {
          setError("Invalid OTP. Please try again.");
        }
      } catch (error) {
        console.error("Submit OTP Error:", error);
        setError(error.response?.data?.detail || "An error occurred.");
      } finally {
        setLoading(false);
      }
    } else {
      setError("Please enter a 6-digit OTP.");
      setLoading(false);
    }
  };

  const handleResendotp = async (e) => {
    e.preventDefault();
    setLoading(true);

    let endpoint;
    console.log("selecting endpoint:", source);
    console.log("role:", role);

    if (source === "forget-password") {
      if (role === "Admin") {
        endpoint = "/admin-user-Forget-Password-Email/";
      } else if (
        role === "Interviewer" ||
        role === "OrgAdmin" ||
        role === "HR"
      ) {
        endpoint = "/org-user-Forget-Password-Email/";
      } else if (role === "TP_Interviewer") {
        endpoint = "/Forget-Password/"; // generic endpoint
      } else if (role === "Candidate") {
        endpoint = "/send-otp-to-candidate";
      }
    } else if (source === "candidateLogin") {
      endpoint = "/send-otp-to-candidate";
    } else if (source === "interviewerRegister") {
      endpoint = "/interviewer_Verify_OTP/";
    } else {
      console.log("Invalid source or role for resend OTP");
      setError("Cannot resend OTP. Invalid source or role.");
      setLoading(false);
      return;
    }

    if (!endpoint) {
      setError("Unable to determine resend OTP endpoint.");
      setLoading(false);
      return;
    }

    try {
      // Use GET request for resend OTP
      const response = await aiDishaApi.get(endpoint, {
        params: { email: email },
      });

      console.log("Resend OTP Response:", response.data);
      Toast.success("OTP Resent Successfully!");
    } catch (error) {
      console.error("Resend OTP Error:", error);
      Toast.error("Failed to resend OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center gap-4">
      <h2 className="text-center gradient-text">OTP Verification</h2>
      <p className="info-text">Enter the One Time Password</p>
      <p className="info-text">
        We have sent the verification code to your email address
      </p>
      <form onSubmit={handleSubmit} className="d-flex flex-column gap-4">
        <div className="d-flex justify-content-center gap-2 m-4">
          {otp.map((value, index) => (
            <input
              key={index}
              type="text"
              className="otp"
              value={value}
              onChange={(e) => handleChange(index, e)}
              maxLength="1"
              required
            />
          ))}
        </div>
        {error && <span className="text-danger text-center">{error}</span>}
        <p className="text-end info-text">
          If you didn't receive a code, click -
          <span className="fw-normal fs-6 resend-text text-end" id="resend">
            <Link
              sx={{ cursor: "pointer" }}
              onClick={(e) => handleResendotp(e)}
            >
              Resend
            </Link>
          </span>
        </p>
        <div className="text-center">
          <Button type="submit" className="gradient-button" disabled={loading}>
            {loading ? <Loader /> : "Confirm"}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default OtpAuth;
